import React from 'react'
import { Link } from 'react-router-dom'
import PageTitle from './includes/PageTitle'


export default function OrderSuccessful() {
  return (
    <>
        <PageTitle title="Your Order Was Successful - ALMOSTINVISIBLE" />
        <div className="d-flex align-content-center flex-column container justify-content-start" style={{margin: "30vh auto"}}>
            <div>
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="7em" width="7em" xmlns="http://www.w3.org/2000/svg"><g><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 1a5 5 0 0 1 5 5v2h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3V6a5 5 0 0 1 5-5zm5 10h-2v1a1 1 0 0 0 1.993.117L17 12v-1zm-8 0H7v1a1 1 0 0 0 1.993.117L9 12v-1zm3-8a3 3 0 0 0-2.995 2.824L9 6v2h6V6a3 3 0 0 0-2.824-2.995L12 3z"></path></g></svg>
            </div>
            <div className="d-flex flex-column">
                <h1 className="unbounded" style={{fontSize: "50px"}}>
                    Your Order Was Successful
                </h1>
                <p className='nunito-2 fw-bold'>
                    Your order will be delivered to you in 3-5 business days.
                    You can <Link to='contact' className='unbounded black-link fw--light'>Contact Us.</Link>
                    
                    <br />
                    Thank you.
                </p>
            </div>
            
        </div>
    </>
  )
}
